import React, { useEffect, useState } from "react";
import axios from "./axios";
import requests from "./requests";
import YouTube from "react-youtube";
import movieTrailer from "movie-trailer";
import { useMediaPredicate } from "react-media-hook";
import "./Banner.css";

function Banner() {
  const lessthan500 = useMediaPredicate("(max-width: 500px)");
  const [movie, setMovie] = useState([]);
  var [trailerUrl, setTrailerUrl] = useState("");
  useEffect(() => {
    async function fetchData() {
      const request = await axios.get(requests.fetchNetflixOriginals);
      setMovie(
        request.data.results[
          Math.floor(Math.random() * (request.data.results.length - 1))
        ]
      );
      return request;
    }
    fetchData();
  }, []);
  function truncate(str, n) {
    return str?.length > n ? str.substr(0, n - 1) + "..." : str;
  }
  const opts = {
    height: "390",
    width: "100%",
    playerVars: {
      autoplay: 1,
      origin: "https://localhost:3000",
    },
    //https://youtu.be/KS2EztRMuRw
  };
  const trailerplay = () => {
    console.log(movie.name);
    if (trailerUrl) {
      setTrailerUrl("");
    } else if (movie.name === "Money Heist") {
      setTrailerUrl("htqXL94Rza4");
    } else if (movie.name === "Lucifer") {
      setTrailerUrl("ueMwVGBwqRo");
    } else if (movie.name === "Sex/Life") {
      setTrailerUrl("x580mowu5Gs");
    } else if (movie.name === "The Snitch Cartel: Origins") {
      setTrailerUrl("vYZSxXcwJmw");
    } else if (movie.name === "Elite") {
      setTrailerUrl("QNwhAdrdwp0");
    } else if (movie.name === "Cobra Kai") {
      setTrailerUrl("xCwwxNbtK6Y");
    } else if (movie.name === "Control Z") {
      setTrailerUrl("P9rEPJ65UIw");
    } else if (movie.name === "Open Your Eyes") {
      setTrailerUrl("7LvSyuM6XSU");
    } else if (movie.name === "Sex Education") {
      setTrailerUrl("Hd2ldTR-WpI");
    } else if (movie.name === "Record of Ragnarok") {
      setTrailerUrl("z_pzeLrog8c");
    } else if (movie.name === "Ragnarok") {
      setTrailerUrl("i2qDt5D8RSs");
    } else if (movie.name === "Stranger Things") {
      setTrailerUrl("e4XvO7DItmc");
    } else if (movie.name === "Sweet Tooth") {
      setTrailerUrl("9zG9RuJb3QU");
    } else if (movie.name === "The Umbrella Academy") {
      setTrailerUrl("0DAmWHxeoKw");
    } else if (movie.name === "The War Next-door") {
      setTrailerUrl("JP-DxxcFYR0");
    } else if (movie.name === "Who Killed Sara?") {
      setTrailerUrl("8ctRjR_DWAg");
    } else if (movie.name === "Sexy Beasts") {
      setTrailerUrl("IJO5m6EFL6A");
    } else if (movie.name === "Katla") {
      setTrailerUrl("X9zZl5nov68");
    } else if (movie.name === "Lupin") {
      setTrailerUrl("ga0iTWXCGa0");
    } else if (movie.name === "The Suicide Squad") {
      setTrailerUrl("JuDLepNa7hw");
    } else if (movie.title === "F9") {
      setTrailerUrl("aSiDu3Ywi8E");
    } else if (movie.title === "Shang-Chi and the Legend of the Ten Rings") {
      setTrailerUrl("8YjFbMbfXaQ");
    } else if (movie.title === "Cinderella") {
      setTrailerUrl("T1NeHRuPpoM");
    } else if (movie.title === "Reminiscence") {
      setTrailerUrl("_BggT--yxf0");
    } else if (movie.title === "Vacation Friends") {
      setTrailerUrl("1cKWKyh6d1k");
    } else if (movie.title === "Jungle Cruise") {
      setTrailerUrl("f_HvoipFcA8");
    } else if (movie.name === "See") {
      setTrailerUrl("7Rg0y7NT1gU");
    } else if (movie.name === "The Walking Dead") {
      setTrailerUrl("sfAc2U20uyg");
    } else if (movie.title === "Free Guy") {
      setTrailerUrl("X2m-08cOAbc");
    } else if (movie.name === "The Tomorrow War") {
      setTrailerUrl("QPistcpGB8o");
    } else if (movie.title === "Narco Sub") {
      setTrailerUrl("xFye5F5DdMY");
    } else if (movie.title === "Infinite") {
      setTrailerUrl("_WWEOCQGxSw");
    } else if (movie.name === "Chilling Adventures of Sabrina") {
      setTrailerUrl("R2gbPxeNk2E");
    } else if (movie.title === "Mortal Kombat") {
      setTrailerUrl("NYH2sLid0Zc");
    } else if (movie.title === "Wrath of Man") {
      setTrailerUrl("EFYEni2gsK0");
    } else if (movie.title === "The Boss Baby: Family Business") {
      setTrailerUrl("QPzy8Ckza08");
    } else {
      if (trailerUrl) {
        setTrailerUrl("");
      } else {
        movieTrailer(movie?.name || movie?.title || movie?.original_name || "")
          .then((url) => {
            const urlParams = new URLSearchParams(new URL(url).search);
            setTrailerUrl(urlParams.get("v"));
          })
          .catch((error) => console.log(error));
      }
    }
  };
  return (
    <div>
      <header
        className="banner"
        style={{
          backgroundSize: "cover",

          backgroundImage: `url(https://www.themoviedb.org/t/p/w533_and_h300_bestv2/${
            lessthan500 ? movie.poster_path : movie?.backdrop_path
          })`,
          backgroundPosition: "center center",
        }}
      >
        <div className="banner-content">
          <h1 className="banner-title">
            {movie?.title || movie?.name || movie?.originalname}
          </h1>
          {movie?.first_air_date && movie?.vote_average && (
            <p>
              Release date: {movie.first_air_date} &nbsp; Rating:{" "}
              {movie.vote_average}
              /10
            </p>
          )}

          <div className="banner-buttons">
            <button
              className="banner-button"
              onClick={() => trailerplay(movie)}
            >
              {trailerUrl ? "Close" : "Play"}
            </button>
            <button className="banner-button">My List</button>
          </div>
          <p className="banner-description">{truncate(movie?.overview, 175)}</p>
        </div>
        <div className="banner-bottomfade"></div>
      </header>
      {trailerUrl && <YouTube videoId={trailerUrl} opts={opts} />}
    </div>
  );
}
export default Banner;
